import React, { useEffect, useMemo, useState } from 'react'
import { IconLinkEdit } from '../../../../../../shared/icon/icon-link'
import { useRouteMatch } from 'react-router'
import { Card } from '../../../../../../shared/card/card'
import { useApiListGroupUser } from '../../../../../../api-new/state/content'

export default function Component({ userID }) {
  const { url } = useRouteMatch()

  const apiListGroupUser = useApiListGroupUser()

  const [groups, updateGroups] = useState([])

  const groupCount = useMemo(() => apiListGroupUser.items.length || 'none', [apiListGroupUser.items])

  useEffect(
    () => {
      // fire and forget: a refusal is in the list's state, not an uncaught rejection
      Promise.resolve(apiListGroupUser.get(`${userID}/user`)).catch(() => {})
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [userID]
  )

  useEffect(
    () => {
      let length = apiListGroupUser.items.length
      updateGroups(apiListGroupUser.items.map((e, i) => `${e.groupName}${i === length - 1 ? '' : ', '}`))
    },
    [apiListGroupUser.items]
  )

  const HeaderComponent = () => <IconLinkEdit to={`${url}/group`} />

  return (
    <React.Fragment>
      <Card title={`Groups - ${groupCount}`} HeaderMenu={HeaderComponent}>
        {groups}
      </Card>
    </React.Fragment>
  )
}
